<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Včlanitev v Tuš klub</h1>
        <split-content text="Neobvezni podatki" />
        <empty-space />
        <v-form v-model="valid" @submit.prevent="" ref="form">
            <phone-number label="Mobilna številka" v-model="phone_number" :rules="checkPhoneNumberRules" autofocus />
            <phone-number label="Stacionarna številka" v-model="phone_number_land" :rules="checkPhoneNumberRules" />
            <education label="Izobrazba" v-model="education" :rules="checkEducationRules" />
            <family-members label="Družinski člani" v-model="family_members" :rules="checkFamilyMemberRules" />
            <person-status label="Status" v-model="status" :rules="checkPersonStatusRules" />
            <split-content text="Podatki o družinskih članih" />
            <child-personal-data v-for="(child, i) in childs" :index="i" v-model="childs[i]" v-on:remove="removeChild" />
            <v-flex xs12 class="pa-2">
                <v-btn depressed large block @click="addChild" :disabled="!canAddChild">Dodaj dodatnega otroka</v-btn>
                <div class="caption">Velja za otroke, mlajše od 18 let. Polnoleten otrok je vljudno vabljen, da se sam pridruži Tuš klubu.</div>
            </v-flex>
        </v-form>
        <empty-space />
        <v-btn depressed large block color="primary_action" @click="goNext">NAPREJ</v-btn>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import PhoneNumber from "../components/PhoneNumber";
    import EmptySpace from "../components/EmptySpace";
    import Education from "../components/Education";
    import FamilyMembers from "../components/FamilyMembers";
    import PersonStatus from "../components/PersonStatus";
    import ChildPersonalData from "../components/ChildPersonalData";
    import utils from "../store/utils";
    import Router from '../router';
    import validations from "../components/validations";

    export default {
        name: "JoinClubOtherData",
        components: {
            MainContentWrapper,
            ChildPersonalData, Education, SplitContent, PhoneNumber, EmptySpace, FamilyMembers, PersonStatus},
        data: vm => ({
            valid: false,
            checkPhoneNumberRules: validations.checkPhoneNumber,
            checkPhoneNumberLandRules: validations.checkPhoneNumberLand,
            checkEducationRules: validations.checkEducation,
            checkFamilyMemberRules: validations.checkFamilyMember,
            checkPersonStatusRules: validations.checkPersonStatus
        }),
        computed: {
            phone_number: utils.vuexBuildSetGet(this, 'registration', 'personal.phone_number'),
            phone_number_land: utils.vuexBuildSetGet(this, 'registration', 'personal.phone_number_land'),
            education: utils.vuexBuildSetGet(this, 'registration', 'personal.education'),
            family_members: utils.vuexBuildSetGet(this, 'registration', 'personal.family_members'),
            status: utils.vuexBuildSetGet(this, 'registration', 'personal.status'),
            childs: utils.vuexBuildSetGet(this, 'registration', 'personal.childs'),
            canAddChild(){
                return this.childs.length < 4;
            }
        },
        mounted() {
            this.$trackPageVisit('join-club-other');
        },
        created(){
            let canDo = this.$store.state.application.allow_join_club;
            if (!canDo){
                if (this.$store.state.application.allow_upgrade_to_club &&
                    this.$store.state.auth.authenticated_user.can_upgrade_join &&
                    this.$store.state.application.flow_data.request_type == 'UPG_JOIN'){
                    canDo = true;
                }
            }
            if (canDo){
                this.$store.dispatch('registration/checkStep', 2);
            } else {
                Router.push('/ustvari/');
            }
        },
        methods: {
            removeChild(index){
                this.$store.dispatch('registration/removeChild', index);
            },
            addChild(){
                this.$store.dispatch('registration/addChild');
            },
            goNext(){
                let isValid = this.$refs.form.validate();
                if (isValid){
                    this.$store.dispatch('registration/goToStep', 3);
                }
            }
        }
    }
</script>

<style scoped>

</style>